import { render } from "./CommunicationAndTraining.vue?vue&type=template&id=4f572f9a&ts=true"
import script from "./CommunicationAndTraining.vue?vue&type=script&lang=ts"
export * from "./CommunicationAndTraining.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__